export default function configReducer(
  state = {
    name: 'VisionSupport 2.0',
    description: 'Nejvíc topapp z dýpu!',
    url: 'https://podpora.deepvision.cz',
    layout: 'layout-1',
    collapsed: false,
    rightSidebar: false,
    backdrop: false
  },
  action
) {
  switch (action.type) {
    case 'SET_CONFIG':
      return {
        ...state,
        ...action.config
      }
    case 'SET_CONFIG_KEY':
      let {key, value} = {...action}
      return {
        ...state,
        [`${key}`]: value
      }
    default:
      return state
  }
}
